// todo: [dima] why do we need this?
// if( !(window as any).process )
//     (window as any).process = {};
// if( !(window as any).process.env )
//     (window as any).process.env = {};
// (window as any).process.env.NODE_ENV = 'production';

declare var __webpack_public_path__:string|undefined;
__webpack_public_path__ = (window as any).resourceBasePath;

import {rootState} from '@mintdata-wsp/common/state/RootState';
import {pubControllers} from '@mintdata-wsp/pub/controllers/PubControllers';
import '@mintdata-wsp/pub/styles/pub-global.less';
import {ApplicationView} from '@mintdata-wsp/pub/view/ApplicationView';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const bootstrap = async () =>
{
    // because webpack is not smart enough to handle cyclic imports in all cases,
    // we has to import rootState early-on here to force initialization for state modules (RootState, etc..)
    if (rootState) {
        console.log("Root State loaded")
    }

    pubControllers.initialize();

    const reactRoot = document.getElementById('react-host');
    ReactDOM.render(<ApplicationView />, reactRoot);

    return pubControllers.design.loadDesign();
};

bootstrap();
